module.exports = __webpack_public_path__ + "img/IMG_4885-min.82b7ba5f.jpg";